import React, { useState, useEffect, useRef } from 'react';
import * as faceapi from 'face-api.js';
import {
  Container,
  CameraWrapper,
  Video,
  Canvas,
  Status,
  ButtonGroup,
  Button,
  BodyCamera,
} from './Styles.Selfie.js';
// ##############################################

export function CameraSelfie({ setMostrarCamera, setselfieCapturada, veiculoPlaca }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const modelsLoaded = useRef(false);
  const intervalRef = useRef(null);
  const montado = useRef(true);

  const [carregando, setCarregando] = useState(false);
  const [ativo, setAtivo] = useState(false);
  const [rostoDetectado, setRostoDetectado] = useState(false);
  const [stream, setStream] = useState(null);

  // Limpar recursos ao desmontar
  useEffect(() => {
    montado.current = true;
    return () => {
      montado.current = false;
      pararCamera();
    };
    // eslint-disable-next-line
  }, []);

  // Carregar modelos do face-api ----------------------
  const carregarModelos = async () => {
    try {
      setCarregando(true);
      const MODEL_URL = '/models';
      
      await Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      ]);
      
      modelsLoaded.current = true;
      setCarregando(false);
    } catch (error) {
      console.error('Erro ao carregar modelos:', error);
      alert('Erro ao carregar modelos de IA. Verifique se os arquivos estão em /public/models/');
      setCarregando(false);
    }
  };

  // Inicializar câmera----------------------
  const iniciarCamera = async () => {
    try {
      if (!modelsLoaded.current) {
        await carregarModelos();
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        alert('Câmera indisponível. Use HTTPS ou um navegador compatível.');
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { 
          width: 640, 
          height: 480,
          facingMode: 'user', // Câmera frontal
          frameRate: { ideal: 10, max: 30 },
        },
        audio: false,
      });

      if (!montado.current) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }

      setStream(stream)

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        
        // Aguardar vídeo estar pronto
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play();
          setAtivo(true);
          detectarRosto();
        };
      }
    } catch (error) {
      console.error('Erro ao acessar câmera:', error);
      alert('Não foi possível acessar a câmera');
    }
  };

  // Detectar rosto em tempo real ----------------------
  const detectarRosto = async () => {
    if (!videoRef.current || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const video = videoRef.current;

    // Dimensionar o canvas para corresponder ao vídeo
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval( async () => {
      if (!montado.current || !videoRef.current || !videoRef.current.srcObject || video.readyState < 2) return;
      let detections;
      try {
        detections = await faceapi
          .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
          .withFaceLandmarks()
          .withFaceExpressions();
      } catch (e) {
        return;
      }
      if (!montado.current) return;

      // Limpar canvas
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Desenhar detecções no canvas usando funções do face-api
      if (detections.length > 0) {
        setRostoDetectado(true);
        // Desenhar caixa de detecção
        faceapi.draw.drawDetections(canvas, detections);
        // Desenhar landmarks (pontos de referência faciais)
        // faceapi.draw.drawFaceLandmarks(canvas, detections);
        // Desenhar expressões faciais
        faceapi.draw.drawFaceExpressions(canvas, detections);
      } else {
        setRostoDetectado(false);
      }

      // Continuar detectando
      // if (ativo) {
      //   animationRef.current = requestAnimationFrame(detectarRosto);
      // };

    }, 100);
  };
  // Capturar foto ----------------------
  const CapturarFoto = () => {
    if (!videoRef.current) return;
    const video = videoRef.current;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Adicionar data, hora e nome na imagem
    const agora = new Date();
    const data = agora.toLocaleDateString('pt-BR');
    const hora = agora.toLocaleTimeString('pt-BR');
    const texto1 = `${veiculoPlaca}`;
    const texto2 = `${data} - ${hora}`;
    const texto3 = `mais_apoio`;

    // Calcular tamanho de fonte proporcional à imagem
    const fontSize = Math.floor(canvas.height * 0.06); // 6% da altura do canvas
    const padding = Math.floor(canvas.width * 0.02); // 2% da largura do canvas
    const lineHeight = fontSize * 1.3;

    // Configurar fonte e estilo
    ctx.font = `bold ${fontSize}px Arial`;
    ctx.fillStyle = '#ffffff';
    ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
    ctx.shadowBlur = Math.floor(fontSize * 0.3);
    ctx.shadowOffsetX = Math.floor(fontSize * 0.15);
    ctx.shadowOffsetY = Math.floor(fontSize * 0.15);

    // Posicionar no canto inferior direito
    const xPos = canvas.width - padding;
    const yPos = canvas.height - padding;

    // Desenhar textos (de baixo para cima)
    ctx.textAlign = 'right';
    ctx.fillText(texto3, xPos, yPos);
    ctx.fillText(texto2, xPos, yPos - lineHeight);
    ctx.fillText(texto1, xPos, yPos - lineHeight * 2);

    const imagemBase64 = canvas.toDataURL('image/png', 1.0); // Qualidade 100%
    setselfieCapturada(imagemBase64);

    pararCamera();
    setMostrarCamera(false);
  };

  // Parar câmera ----------------------
  const pararCamera = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
      if (montado.current) {
        setAtivo(false);
        setRostoDetectado(false);
      }
    }

    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }

    // Limpar canvas
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }
  };

  // ---------------------------------
  useEffect(() => {
    iniciarCamera();
  }, []);

  // ------------------------------

  
  //   ####################################################
  return (
    <BodyCamera 
    fundoBloque={stream}
    >
      <div className='fundoBloque' />
      <Container>
        <Button
          className="parar"
          style={{position:"absolute", top:'30px', right:'10px', zIndex:3}}
          onClick={() => {
            pararCamera();
            setMostrarCamera(false);
          }}
          >
            X
        </Button>

        <span style={{fontSize:"20px"}}> DETECÇÃO FACIAL </span>

        <CameraWrapper ativo={ativo} rostoDetectado={rostoDetectado}>
          <Video ref={videoRef} />
          <Canvas ref={canvasRef} />
        </CameraWrapper>

        <Status>
          {carregando && '⏳ Carregando modelos...'}
          {!carregando && ativo && rostoDetectado && '✅ Rosto detectado!'}
          {!carregando && ativo && !rostoDetectado && '⏳ Aguardando rosto...'}
          {!ativo && '⏸️ Câmera inativa'}
        </Status>

        <ButtonGroup>
          <Button
            className="iniciar"
            disabled={rostoDetectado ? false : true}
            onClick={CapturarFoto}
          >
            Capturar
          </Button>
          
        </ButtonGroup>
      </Container>
    </BodyCamera>
  );
};
